// ceid format (ASFE-14434): a random UUIDv4 per pushed event.
//
// Must stay fully self-contained (no imports, no outer-scope references):
// html-head-template.tsx inlines the compiled function into <script> tags via
// .toString(), where it runs without any module context.
export const createClientEventId = (): string => {
  const cryptoObj = typeof crypto !== 'undefined' ? crypto : undefined;

  const cryptoWithUUID = cryptoObj as {randomUUID?: () => string} | undefined;
  if (cryptoWithUUID && typeof cryptoWithUUID.randomUUID === 'function') {
    return cryptoWithUUID.randomUUID();
  }

  if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(16));
    bytes[6] = ((bytes[6] || 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] || 0) & 0x3f) | 0x80;
    let hex = '';
    for (let i = 0; i < 16; i++) {
      const byte = bytes[i] || 0;
      hex += (byte < 16 ? '0' : '') + byte.toString(16);
    }
    return (
      hex.slice(0, 8) +
      '-' +
      hex.slice(8, 12) +
      '-' +
      hex.slice(12, 16) +
      '-' +
      hex.slice(16, 20) +
      '-' +
      hex.slice(20)
    );
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};
